<app-form-wrapper [title]="messagesService.savedMessages.length ? 'In this campaign (' + messagesService.savedMessages.length + ')' : 'In this campaign'">
  <div class="pv">
    @if (messagesService.savedMessages.length < 1) {
      <p class="pv__empty">Messages you add appear here. Open one to edit it.</p>
    } @else {
      <ol class="pv__rows">
        @for (message of messagesService.savedMessages; track message.id) {
          <li class="pv__row">
            <button
              type="button"
              class="pv__row-main"
              [attr.aria-label]="'Edit message ' + ($index + 1) + ', ' + (message.subject || 'untitled')"
              (click)="openPopup(message, $index + 1)"
            >
              <span class="pv__row-title">{{ message.subject || "Untitled message" }}</span>
              <span class="pv__row-sub">{{ partsLabel(message.body) }} · from {{ message.senderId || "no sender" }}</span>
            </button>
            <span class="pv__row-actions">
              <button
                type="button"
                class="bk-icon-btn"
                [attr.aria-label]="'Edit ' + (message.subject || 'message')"
                matTooltip="Edit"
                (click)="openPopup(message, $index + 1)"
              >
                <span class="bk-sym" aria-hidden="true">edit</span>
              </button>
              <button
                type="button"
                class="bk-icon-btn is-danger"
                [attr.aria-label]="'Remove ' + (message.subject || 'message')"
                matTooltip="Remove from campaign"
                (click)="deleteMessage(message.id, $event)"
              >
                <span class="bk-sym" aria-hidden="true">delete</span>
              </button>
            </span>
          </li>
        }
      </ol>
    }
  </div>
</app-form-wrapper>
